var items = {
  "block.minecraft.air": "氣",
  "block.minecraft.stone": "石",
  "block.minecraft.granite": "花崗巖",
  "block.minecraft.polished_granite": "鎣花崗",
  "block.minecraft.diorite": "閃綠石",
  "block.minecraft.polished_diorite": "鎣閃綠",
  "block.minecraft.andesite": "鈉滑碤",
  "block.minecraft.polished_andesite": "鎣鈉滑",
  "block.minecraft.grass_block": "艸方",
  "block.minecraft.dirt": "土",
  "block.minecraft.coarse_dirt": "澱土",
  "block.minecraft.podzol": "灰土",
  "block.minecraft.crimson_nylium": "緋蕈巖",
  "block.minecraft.warped_nylium": "譎蕈巖",
  "block.minecraft.cobblestone": "䃮",
  "block.minecraft.oak_planks": "柞材",
  "block.minecraft.spruce_planks": "樅材",
  "block.minecraft.birch_planks": "樺材",
  "block.minecraft.jungle_planks": "叢莽材",
  "block.minecraft.acacia_planks": "㭜材",
  "block.minecraft.dark_oak_planks": "黯柞材",
  "block.minecraft.crimson_planks": "緋蕈木材",
  "block.minecraft.warped_planks": "譎蕈木材",
  "block.minecraft.oak_sapling": "柞秧",
  "block.minecraft.spruce_sapling": "樅秧",
  "block.minecraft.birch_sapling": "樺秧",
  "block.minecraft.jungle_sapling": "叢莽秧",
  "block.minecraft.acacia_sapling": "㭜秧",
  "block.minecraft.dark_oak_sapling": "黯柞秧",
  "block.minecraft.bedrock": "基石",
  "block.minecraft.sand": "沙",
  "block.minecraft.red_sand": "紅沙",
  "block.minecraft.gravel": "礫",
  "block.minecraft.gold_ore": "金礦",
  "block.minecraft.iron_ore": "鐵礦",
  "block.minecraft.coal_ore": "石炭礦",
  "block.minecraft.nether_gold_ore": "焱界金礦",
  "block.minecraft.oak_log": "柞樁",
  "block.minecraft.spruce_log": "樅樁",
  "block.minecraft.birch_log": "樺樁",
  "block.minecraft.jungle_log": "叢莽樁",
  "block.minecraft.acacia_log": "㭜樁",
  "block.minecraft.dark_oak_log": "黯柞樁",
  "block.minecraft.crimson_stem": "緋蕈柄",
  "block.minecraft.warped_stem": "譎蕈柄",
  "block.minecraft.stripped_oak_log": "既扡柞樁",
  "block.minecraft.stripped_spruce_log": "既扡樅樁",
  "block.minecraft.stripped_birch_log": "既扡樺樁",
  "block.minecraft.stripped_jungle_log": "既扡叢莽樁",
  "block.minecraft.stripped_acacia_log": "既扡㭜樁",
  "block.minecraft.stripped_dark_oak_log": "既扡黯柞樁",
  "block.minecraft.stripped_crimson_stem": "既扡緋蕈柄",
  "block.minecraft.stripped_warped_stem": "既扡譎蕈柄",
  "block.minecraft.stripped_oak_wood": "既扡柞木",
  "block.minecraft.stripped_spruce_wood": "既扡樅木",
  "block.minecraft.stripped_birch_wood": "既扡樺木",
  "block.minecraft.stripped_jungle_wood": "既扡叢莽木",
  "block.minecraft.stripped_acacia_wood": "既扡㭜木",
  "block.minecraft.stripped_dark_oak_wood": "既扡黯柞木",
  "block.minecraft.stripped_crimson_hyphae": "既扡緋蕈體",
  "block.minecraft.stripped_warped_hyphae": "既扡譎蕈體",
  "block.minecraft.oak_wood": "柞木",
  "block.minecraft.spruce_wood": "樅木",
  "block.minecraft.birch_wood": "樺木",
  "block.minecraft.jungle_wood": "叢莽木",
  "block.minecraft.acacia_wood": "㭜木",
  "block.minecraft.dark_oak_wood": "黯柞木",
  "block.minecraft.crimson_hyphae": "緋蕈體",
  "block.minecraft.warped_hyphae": "譎蕈體",
  "block.minecraft.oak_leaves": "柞葉",
  "block.minecraft.spruce_leaves": "樅葉",
  "block.minecraft.birch_leaves": "樺葉",
  "block.minecraft.jungle_leaves": "叢莽葉",
  "block.minecraft.acacia_leaves": "㭜葉",
  "block.minecraft.dark_oak_leaves": "黯柞葉",
  "block.minecraft.sponge": "海綿",
  "block.minecraft.wet_sponge": "㵖海綿",
  "block.minecraft.glass": "琉璃",
  "block.minecraft.lapis_ore": "群青礦",
  "block.minecraft.lapis_block": "群青塊",
  "block.minecraft.dispenser": "射械",
  "block.minecraft.sandstone": "砂",
  "block.minecraft.chiseled_sandstone": "鏨砂",
  "block.minecraft.cut_sandstone": "割砂",
  "block.minecraft.note_block": "音符盒",
  "block.minecraft.powered_rail": "速軌",
  "block.minecraft.detector_rail": "測軌",
  "block.minecraft.sticky_piston": "黏膠韝韛",
  "block.minecraft.cobweb": "蛛網",
  "block.minecraft.grass": "艸",
  "block.minecraft.fern": "蕨",
  "block.minecraft.dead_bush": "枯木",
  "block.minecraft.seagrass": "海艸",
  "block.minecraft.sea_pickle": "海鞘",
  "block.minecraft.piston": "韝韛",
  "block.minecraft.white_wool": "白羊毛",
  "block.minecraft.orange_wool": "橙羊毛",
  "block.minecraft.magenta_wool": "赬羊毛",
  "block.minecraft.light_blue_wool": "縹羊毛",
  "block.minecraft.yellow_wool": "黃羊毛",
  "block.minecraft.lime_wool": "翠羊毛",
  "block.minecraft.pink_wool": "粉羊毛",
  "block.minecraft.gray_wool": "灰羊毛",
  "block.minecraft.light_gray_wool": "蒼羊毛",
  "block.minecraft.cyan_wool": "黛羊毛",
  "block.minecraft.purple_wool": "紫羊毛",
  "block.minecraft.blue_wool": "靛羊毛",
  "block.minecraft.brown_wool": "褐羊毛",
  "block.minecraft.green_wool": "綠羊毛",
  "block.minecraft.red_wool": "紅羊毛",
  "block.minecraft.black_wool": "黑羊毛",
  "block.minecraft.dandelion": "蒲公英",
  "block.minecraft.poppy": "虞美人",
  "block.minecraft.blue_orchid": "蘭",
  "block.minecraft.allium": "碩葱",
  "block.minecraft.azure_bluet": "美耳草",
  "block.minecraft.red_tulip": "紅鬱金香",
  "block.minecraft.orange_tulip": "橙鬱金香",
  "block.minecraft.white_tulip": "白鬱金香",
  "block.minecraft.pink_tulip": "粉鬱金香",
  "block.minecraft.oxeye_daisy": "雛菊",
  "block.minecraft.cornflower": "矢車菊",
  "block.minecraft.lily_of_the_valley": "鈴蘭",
  "block.minecraft.wither_rose": "凋零玫瑰",
  "block.minecraft.brown_mushroom": "褐蕈",
  "block.minecraft.red_mushroom": "紅蕈",
  "block.minecraft.crimson_fungus": "緋蕈",
  "block.minecraft.warped_fungus": "譎蕈",
  "block.minecraft.crimson_roots": "緋蕈索",
  "block.minecraft.warped_roots": "譎蕈索",
  "block.minecraft.nether_sprouts": "焱界苗",
  "block.minecraft.weeping_vines": "垂泣藤",
  "block.minecraft.twisting_vines": "輪囷藤",
  "block.minecraft.sugar_cane": "果蔗",
  "block.minecraft.kelp": "海帶",
  "block.minecraft.bamboo": "竹",
  "block.minecraft.gold_block": "金塊",
  "block.minecraft.iron_block": "鐵塊",
  "block.minecraft.oak_slab": "柞版",
  "block.minecraft.spruce_slab": "樅版",
  "block.minecraft.birch_slab": "樺版",
  "block.minecraft.jungle_slab": "叢莽版",
  "block.minecraft.acacia_slab": "㭜版",
  "block.minecraft.dark_oak_slab": "黯柞版",
  "block.minecraft.crimson_slab": "緋蕈木版",
  "block.minecraft.warped_slab": "譎蕈木版",
  "block.minecraft.stone_slab": "巖版",
  "block.minecraft.smooth_stone_slab": "潤巖版",
  "block.minecraft.sandstone_slab": "砂版",
  "block.minecraft.cut_sandstone_slab": "割砂版",
  "block.minecraft.petrified_oak_slab": "巖化柞版",
  "block.minecraft.cobblestone_slab": "䃮版",
  "block.minecraft.brick_slab": "磚版",
  "block.minecraft.stone_brick_slab": "巖磚版",
  "block.minecraft.nether_brick_slab": "焱界磚版",
  "block.minecraft.quartz_slab": "石英版",
  "block.minecraft.red_sandstone_slab": "紅砂版",
  "block.minecraft.cut_red_sandstone_slab": "割紅砂版",
  "block.minecraft.purpur_slab": "紫珀版",
  "block.minecraft.prismarine_slab": "海磷版",
  "block.minecraft.prismarine_brick_slab": "海磷磚版",
  "block.minecraft.dark_prismarine_slab": "黯磷版",
  "block.minecraft.smooth_quartz": "潤石英塊",
  "block.minecraft.smooth_red_sandstone": "潤紅砂",
  "block.minecraft.smooth_sandstone": "潤砂",
  "block.minecraft.smooth_stone": "潤巖",
  "block.minecraft.bricks": "磚",
  "block.minecraft.tnt": "炸藥",
  "block.minecraft.bookshelf": "書櫥",
  "block.minecraft.mossy_cobblestone": "苔䃮",
  "block.minecraft.obsidian": "黑曜石",
  "block.minecraft.torch": "炬",
  "block.minecraft.end_rod": "終界燭",
  "block.minecraft.chorus_plant": "頌緲枝",
  "block.minecraft.chorus_flower": "頌緲花",
  "block.minecraft.purpur_block": "紫珀塊",
  "block.minecraft.purpur_pillar": "紫珀柱",
  "block.minecraft.purpur_stairs": "紫珀階",
  "block.minecraft.spawner": "孳衍籠",
  "block.minecraft.oak_stairs": "柞階",
  "block.minecraft.chest": "箱",
  "block.minecraft.diamond_ore": "金剛石礦",
  "block.minecraft.diamond_block": "金剛石塊",
  "block.minecraft.crafting_table": "製物案",
  "block.minecraft.farmland": "疇",
  "block.minecraft.furnace": "爐",
  "block.minecraft.ladder": "梯",
  "block.minecraft.rail": "軌",
  "block.minecraft.cobblestone_stairs": "䃮階",
  "block.minecraft.lever": "閘刀",
  "block.minecraft.stone_pressure_plate": "石踏板",
  "block.minecraft.oak_pressure_plate": "柞踏板",
  "block.minecraft.spruce_pressure_plate": "樅踏板",
  "block.minecraft.birch_pressure_plate": "樺踏板",
  "block.minecraft.jungle_pressure_plate": "叢莽踏板",
  "block.minecraft.acacia_pressure_plate": "㭜踏板",
  "block.minecraft.dark_oak_pressure_plate": "黯柞踏板",
  "block.minecraft.crimson_pressure_plate": "緋蕈木踏板",
  "block.minecraft.warped_pressure_plate": "譎蕈木踏板",
  "block.minecraft.polished_blackstone_pressure_plate": "鎣黑巖踏板",
  "block.minecraft.redstone_ore": "紅石礦",
  "block.minecraft.redstone_torch": "紅石炬",
  "block.minecraft.snow": "雪",
  "block.minecraft.ice": "冰",
  "block.minecraft.snow_block": "雪塊",
  "block.minecraft.cactus": "仙人掌",
  "block.minecraft.clay": "埴塊",
  "block.minecraft.jukebox": "留聲機",
  "block.minecraft.oak_fence": "柞檻",
  "block.minecraft.spruce_fence": "樅檻",
  "block.minecraft.birch_fence": "樺檻",
  "block.minecraft.jungle_fence": "叢莽檻",
  "block.minecraft.acacia_fence": "㭜檻",
  "block.minecraft.dark_oak_fence": "黯柞檻",
  "block.minecraft.crimson_fence": "緋蕈木檻",
  "block.minecraft.warped_fence": "譎蕈木檻",
  "block.minecraft.pumpkin": "南瓜",
  "block.minecraft.carved_pumpkin": "雕南瓜",
  "block.minecraft.netherrack": "焱界石",
  "block.minecraft.soul_sand": "靈沙",
  "block.minecraft.soul_soil": "靈土",
  "block.minecraft.basalt": "黑堦石",
  "block.minecraft.polished_basalt": "鎣黑堦石",
  "block.minecraft.soul_torch": "靈炬",
  "block.minecraft.glowstone": "硄",
  "block.minecraft.jack_o_lantern": "南瓜燈",
  "block.minecraft.oak_trapdoor": "柞窖門",
  "block.minecraft.spruce_trapdoor": "樅窖門",
  "block.minecraft.birch_trapdoor": "樺窖門",
  "block.minecraft.jungle_trapdoor": "叢莽窖門",
  "block.minecraft.acacia_trapdoor": "㭜窖門",
  "block.minecraft.dark_oak_trapdoor": "黯柞窖門",
  "block.minecraft.crimson_trapdoor": "緋蕈木窖門",
  "block.minecraft.warped_trapdoor": "譎蕈木窖門",
  "block.minecraft.infested_stone": "蠹蝕巖",
  "block.minecraft.infested_cobblestone": "蟲蝕䃮",
  "block.minecraft.infested_stone_bricks": "蟲蝕巖磚",
  "block.minecraft.infested_mossy_stone_bricks": "蟲蝕苔磚",
  "block.minecraft.infested_cracked_stone_bricks": "蟲蝕裂磚",
  "block.minecraft.infested_chiseled_stone_bricks": "蟲蝕鏨磚",
  "block.minecraft.stone_bricks": "巖磚",
  "block.minecraft.mossy_stone_bricks": "苔磚",
  "block.minecraft.cracked_stone_bricks": "裂磚",
  "block.minecraft.chiseled_stone_bricks": "鏨磚",
  "block.minecraft.brown_mushroom_block": "褐蕈塊",
  "block.minecraft.red_mushroom_block": "紅蕈塊",
  "block.minecraft.mushroom_stem": "蕈莖",
  "block.minecraft.iron_bars": "鐵杆",
  "block.minecraft.chain": "鏈",
  "block.minecraft.glass_pane": "琉璃嵌板",
  "block.minecraft.melon": "寒瓜",
  "block.minecraft.vine": "藤",
  "block.minecraft.oak_fence_gate": "柞扉",
  "block.minecraft.spruce_fence_gate": "樅扉",
  "block.minecraft.birch_fence_gate": "樺扉",
  "block.minecraft.jungle_fence_gate": "叢莽扉",
  "block.minecraft.acacia_fence_gate": "㭜扉",
  "block.minecraft.dark_oak_fence_gate": "黯柞扉",
  "block.minecraft.crimson_fence_gate": "緋蕈木扉",
  "block.minecraft.warped_fence_gate": "譎蕈木扉",
  "block.minecraft.brick_stairs": "磚階",
  "block.minecraft.stone_brick_stairs": "巖磚階",
  "block.minecraft.mycelium": "盤菌土",
  "block.minecraft.lily_pad": "蓮葉",
  "block.minecraft.nether_bricks": "焱界磚",
  "block.minecraft.cracked_nether_bricks": "裂焱界磚",
  "block.minecraft.chiseled_nether_bricks": "鏨焱界磚",
  "block.minecraft.nether_brick_fence": "焱界磚檻",
  "block.minecraft.nether_brick_stairs": "焱界磚階",
  "block.minecraft.enchanting_table": "淬靈案",
  "block.minecraft.end_portal_frame": "終界結界門框",
  "block.minecraft.end_stone": "終界巖",
  "block.minecraft.end_stone_bricks": "終界巖磚",
  "block.minecraft.dragon_egg": "龍卵",
  "block.minecraft.redstone_lamp": "紅石燈",
  "block.minecraft.sandstone_stairs": "砂階",
  "block.minecraft.emerald_ore": "祖母綠礦",
  "block.minecraft.ender_chest": "終眇箱",
  "block.minecraft.tripwire_hook": "絆線鉤",
  "block.minecraft.emerald_block": "祖母綠塊",
  "block.minecraft.spruce_stairs": "樅階",
  "block.minecraft.birch_stairs": "樺階",
  "block.minecraft.jungle_stairs": "叢莽階",
  "block.minecraft.crimson_stairs": "緋蕈木階",
  "block.minecraft.warped_stairs": "譎蕈木階",
  "block.minecraft.command_block": "命令塊",
  "block.minecraft.beacon": "烽火臺",
  "block.minecraft.cobblestone_wall": "䃮垣",
  "block.minecraft.mossy_cobblestone_wall": "苔䃮垣",
  "block.minecraft.brick_wall": "磚垣",
  "block.minecraft.prismarine_wall": "海磷垣",
  "block.minecraft.red_sandstone_wall": "紅砂垣",
  "block.minecraft.mossy_stone_brick_wall": "苔磚垣",
  "block.minecraft.granite_wall": "花崗垣",
  "block.minecraft.stone_brick_wall": "巖磚垣",
  "block.minecraft.nether_brick_wall": "焱界巖磚垣",
  "block.minecraft.andesite_wall": "鈉滑垣",
  "block.minecraft.red_nether_brick_wall": "焱界紅磚垣",
  "block.minecraft.sandstone_wall": "砂垣",
  "block.minecraft.end_stone_brick_wall": "終界巖磚垣",
  "block.minecraft.diorite_wall": "閃綠垣",
  "block.minecraft.blackstone_wall": "墨石垣",
  "block.minecraft.polished_blackstone_wall": "鎣墨石垣",
  "block.minecraft.polished_blackstone_brick_wall": "鎣墨石磚垣",
  "block.minecraft.stone_button": "石鈕",
  "block.minecraft.oak_button": "柞鈕",
  "block.minecraft.spruce_button": "樅鈕",
  "block.minecraft.birch_button": "樺鈕",
  "block.minecraft.jungle_button": "叢莽鈕",
  "block.minecraft.acacia_button": "㭜鈕",
  "block.minecraft.dark_oak_button": "黯柞鈕",
  "block.minecraft.crimson_button": "緋蕈木鈕",
  "block.minecraft.warped_button": "譎蕈木鈕",
  "block.minecraft.polished_blackstone_button": "鎣黑巖鈕",
  "block.minecraft.anvil": "鐵砧",
  "block.minecraft.chipped_anvil": "裂鐵砧",
  "block.minecraft.damaged_anvil": "壞鐵砧",
  "block.minecraft.trapped_chest": "機關箱",
  "block.minecraft.light_weighted_pressure_plate": "輕踏板",
  "block.minecraft.heavy_weighted_pressure_plate": "重踏板",
  "block.minecraft.daylight_detector": "測暉儀",
  "block.minecraft.redstone_block": "紅石塊",
  "block.minecraft.nether_quartz_ore": "石英礦",
  "block.minecraft.hopper": "漏斗",
  "block.minecraft.chiseled_quartz_block": "鏨石英塊",
  "block.minecraft.quartz_block": "石英塊",
  "block.minecraft.quartz_bricks": "石英磚",
  "block.minecraft.quartz_pillar": "石英柱",
  "block.minecraft.quartz_stairs": "石英階",
  "block.minecraft.activator_rail": "激軌",
  "block.minecraft.dropper": "擲械",
  "block.minecraft.white_terracotta": "白陶",
  "block.minecraft.orange_terracotta": "橙陶",
  "block.minecraft.magenta_terracotta": "赬陶",
  "block.minecraft.light_blue_terracotta": "縹陶",
  "block.minecraft.yellow_terracotta": "黃陶",
  "block.minecraft.lime_terracotta": "翠陶",
  "block.minecraft.pink_terracotta": "粉陶",
  "block.minecraft.gray_terracotta": "灰陶",
  "block.minecraft.light_gray_terracotta": "蒼陶",
  "block.minecraft.cyan_terracotta": "黛陶",
  "block.minecraft.purple_terracotta": "紫陶",
  "block.minecraft.blue_terracotta": "靛陶",
  "block.minecraft.brown_terracotta": "褐陶",
  "block.minecraft.green_terracotta": "綠陶",
  "block.minecraft.red_terracotta": "紅陶",
  "block.minecraft.black_terracotta": "黑陶",
  "block.minecraft.barrier": "障",
  "block.minecraft.iron_trapdoor": "鐵窖門",
  "block.minecraft.hay_block": "芻束",
  "block.minecraft.white_carpet": "白氍毹",
  "block.minecraft.orange_carpet": "橙氍毹",
  "block.minecraft.magenta_carpet": "赬氍毹",
  "block.minecraft.light_blue_carpet": "縹氍毹",
  "block.minecraft.yellow_carpet": "黃氍毹",
  "block.minecraft.lime_carpet": "翠氍毹",
  "block.minecraft.pink_carpet": "粉氍毹",
  "block.minecraft.gray_carpet": "灰氍毹",
  "block.minecraft.light_gray_carpet": "蒼氍毹",
  "block.minecraft.cyan_carpet": "黛氍毹",
  "block.minecraft.purple_carpet": "紫氍毹",
  "block.minecraft.blue_carpet": "靛氍毹",
  "block.minecraft.brown_carpet": "褐氍毹",
  "block.minecraft.green_carpet": "綠氍毹",
  "block.minecraft.red_carpet": "紅氍毹",
  "block.minecraft.black_carpet": "黑氍毹",
  "block.minecraft.terracotta": "陶",
  "block.minecraft.coal_block": "石炭塊",
  "block.minecraft.packed_ice": "夯冰",
  "block.minecraft.acacia_stairs": "㭜階",
  "block.minecraft.dark_oak_stairs": "黯柞階",
  "block.minecraft.slime_block": "黏膠塊",
  "block.minecraft.grass_path": "徑",
  "block.minecraft.sunflower": "葵花",
  "block.minecraft.lilac": "丁香",
  "block.minecraft.rose_bush": "玫瑰簇",
  "block.minecraft.peony": "牡丹",
  "block.minecraft.tall_grass": "高艸",
  "block.minecraft.large_fern": "大蕨",
  "block.minecraft.white_stained_glass": "白琉璃",
  "block.minecraft.orange_stained_glass": "橙琉璃",
  "block.minecraft.magenta_stained_glass": "赬琉璃",
  "block.minecraft.light_blue_stained_glass": "縹琉璃",
  "block.minecraft.yellow_stained_glass": "黃琉璃",
  "block.minecraft.lime_stained_glass": "翠琉璃",
  "block.minecraft.pink_stained_glass": "粉琉璃",
  "block.minecraft.gray_stained_glass": "灰琉璃",
  "block.minecraft.light_gray_stained_glass": "蒼琉璃",
  "block.minecraft.cyan_stained_glass": "黛琉璃",
  "block.minecraft.purple_stained_glass": "紫琉璃",
  "block.minecraft.blue_stained_glass": "靛琉璃",
  "block.minecraft.brown_stained_glass": "褐琉璃",
  "block.minecraft.green_stained_glass": "綠琉璃",
  "block.minecraft.red_stained_glass": "紅琉璃",
  "block.minecraft.black_stained_glass": "黑琉璃",
  "block.minecraft.white_stained_glass_pane": "白琉璃嵌板",
  "block.minecraft.orange_stained_glass_pane": "橙琉璃嵌板",
  "block.minecraft.magenta_stained_glass_pane": "赬琉璃嵌板",
  "block.minecraft.light_blue_stained_glass_pane": "縹琉璃嵌板",
  "block.minecraft.yellow_stained_glass_pane": "黃琉璃嵌板",
  "block.minecraft.lime_stained_glass_pane": "翠琉璃嵌板",
  "block.minecraft.pink_stained_glass_pane": "粉琉璃嵌板",
  "block.minecraft.gray_stained_glass_pane": "灰琉璃嵌板",
  "block.minecraft.light_gray_stained_glass_pane": "蒼琉璃嵌板",
  "block.minecraft.cyan_stained_glass_pane": "黛琉璃嵌板",
  "block.minecraft.purple_stained_glass_pane": "紫琉璃嵌板",
  "block.minecraft.blue_stained_glass_pane": "靛琉璃嵌板",
  "block.minecraft.brown_stained_glass_pane": "褐琉璃嵌板",
  "block.minecraft.green_stained_glass_pane": "綠琉璃嵌板",
  "block.minecraft.red_stained_glass_pane": "紅琉璃嵌板",
  "block.minecraft.black_stained_glass_pane": "黑琉璃嵌板",
  "block.minecraft.prismarine": "海磷",
  "block.minecraft.prismarine_bricks": "海磷磚",
  "block.minecraft.dark_prismarine": "黯磷",
  "block.minecraft.prismarine_stairs": "海磷階",
  "block.minecraft.prismarine_brick_stairs": "海磷磚階",
  "block.minecraft.dark_prismarine_stairs": "黯磷階",
  "block.minecraft.sea_lantern": "海磷燈",
  "block.minecraft.red_sandstone": "紅砂",
  "block.minecraft.chiseled_red_sandstone": "鏨紅砂",
  "block.minecraft.cut_red_sandstone": "割紅砂",
  "block.minecraft.red_sandstone_stairs": "紅砂階",
  "block.minecraft.repeating_command_block": "循環命令塊",
  "block.minecraft.chain_command_block": "連鎖命令塊",
  "block.minecraft.magma_block": "火漿膏塊",
  "block.minecraft.nether_wart_block": "焱界疣塊",
  "block.minecraft.warped_wart_block": "譎疣塊",
  "block.minecraft.red_nether_bricks": "焱界紅磚",
  "block.minecraft.bone_block": "骨塊",
  "block.minecraft.structure_void": "築闕",
  "block.minecraft.observer": "探械",
  "block.minecraft.shulker_box": "贆櫝",
  "block.minecraft.white_shulker_box": "白贆櫝",
  "block.minecraft.orange_shulker_box": "橙贆櫝",
  "block.minecraft.magenta_shulker_box": "赬贆櫝",
  "block.minecraft.light_blue_shulker_box": "縹贆櫝",
  "block.minecraft.yellow_shulker_box": "黃贆櫝",
  "block.minecraft.lime_shulker_box": "翠贆櫝",
  "block.minecraft.pink_shulker_box": "粉贆櫝",
  "block.minecraft.gray_shulker_box": "灰贆櫝",
  "block.minecraft.light_gray_shulker_box": "蒼贆櫝",
  "block.minecraft.cyan_shulker_box": "黛贆櫝",
  "block.minecraft.purple_shulker_box": "紫贆櫝",
  "block.minecraft.blue_shulker_box": "靛贆櫝",
  "block.minecraft.brown_shulker_box": "褐贆櫝",
  "block.minecraft.green_shulker_box": "綠贆櫝",
  "block.minecraft.red_shulker_box": "紅贆櫝",
  "block.minecraft.black_shulker_box": "黑贆櫝",
  "block.minecraft.white_glazed_terracotta": "白釉陶",
  "block.minecraft.orange_glazed_terracotta": "橙釉陶",
  "block.minecraft.magenta_glazed_terracotta": "赬釉陶",
  "block.minecraft.light_blue_glazed_terracotta": "縹釉陶",
  "block.minecraft.yellow_glazed_terracotta": "黃釉陶",
  "block.minecraft.lime_glazed_terracotta": "翠釉陶",
  "block.minecraft.pink_glazed_terracotta": "粉釉陶",
  "block.minecraft.gray_glazed_terracotta": "灰釉陶",
  "block.minecraft.light_gray_glazed_terracotta": "蒼釉陶",
  "block.minecraft.cyan_glazed_terracotta": "黛釉陶",
  "block.minecraft.purple_glazed_terracotta": "紫釉陶",
  "block.minecraft.blue_glazed_terracotta": "靛釉陶",
  "block.minecraft.brown_glazed_terracotta": "褐釉陶",
  "block.minecraft.green_glazed_terracotta": "綠釉陶",
  "block.minecraft.red_glazed_terracotta": "紅釉陶",
  "block.minecraft.black_glazed_terracotta": "黑釉陶",
  "block.minecraft.white_concrete": "白砼",
  "block.minecraft.orange_concrete": "橙砼",
  "block.minecraft.magenta_concrete": "赬砼",
  "block.minecraft.light_blue_concrete": "縹砼",
  "block.minecraft.yellow_concrete": "黃砼",
  "block.minecraft.lime_concrete": "翠砼",
  "block.minecraft.pink_concrete": "粉砼",
  "block.minecraft.gray_concrete": "灰砼",
  "block.minecraft.light_gray_concrete": "蒼砼",
  "block.minecraft.cyan_concrete": "黛砼",
  "block.minecraft.purple_concrete": "紫砼",
  "block.minecraft.blue_concrete": "靛砼",
  "block.minecraft.brown_concrete": "褐砼",
  "block.minecraft.green_concrete": "綠砼",
  "block.minecraft.red_concrete": "紅砼",
  "block.minecraft.black_concrete": "黑砼",
  "block.minecraft.white_concrete_powder": "白砼粉",
  "block.minecraft.orange_concrete_powder": "橙砼粉",
  "block.minecraft.magenta_concrete_powder": "赬砼粉",
  "block.minecraft.light_blue_concrete_powder": "縹砼粉",
  "block.minecraft.yellow_concrete_powder": "黃砼粉",
  "block.minecraft.lime_concrete_powder": "翠砼粉",
  "block.minecraft.pink_concrete_powder": "粉砼粉",
  "block.minecraft.gray_concrete_powder": "灰砼粉",
  "block.minecraft.light_gray_concrete_powder": "蒼砼粉",
  "block.minecraft.cyan_concrete_powder": "黛砼粉",
  "block.minecraft.purple_concrete_powder": "紫砼粉",
  "block.minecraft.blue_concrete_powder": "靛砼粉",
  "block.minecraft.brown_concrete_powder": "褐砼粉",
  "block.minecraft.green_concrete_powder": "綠砼粉",
  "block.minecraft.red_concrete_powder": "紅砼粉",
  "block.minecraft.black_concrete_powder": "黑砼粉",
  "block.minecraft.turtle_egg": "海龜卵",
  "block.minecraft.dead_tube_coral_block": "枯管珊瑚塊",
  "block.minecraft.dead_brain_coral_block": "枯腦珊瑚塊",
  "block.minecraft.dead_bubble_coral_block": "枯泡珊瑚塊",
  "block.minecraft.dead_fire_coral_block": "枯火珊瑚塊",
  "block.minecraft.dead_horn_coral_block": "枯角珊瑚塊",
  "block.minecraft.tube_coral_block": "管珊瑚塊",
  "block.minecraft.brain_coral_block": "腦珊瑚塊",
  "block.minecraft.bubble_coral_block": "泡珊瑚塊",
  "block.minecraft.fire_coral_block": "火珊瑚塊",
  "block.minecraft.horn_coral_block": "角珊瑚塊",
  "block.minecraft.tube_coral": "管珊瑚",
  "block.minecraft.brain_coral": "腦珊瑚",
  "block.minecraft.bubble_coral": "泡珊瑚",
  "block.minecraft.fire_coral": "火珊瑚",
  "block.minecraft.horn_coral": "角珊瑚",
  "block.minecraft.dead_brain_coral": "枯腦珊瑚",
  "block.minecraft.dead_bubble_coral": "枯泡珊瑚",
  "block.minecraft.dead_fire_coral": "枯火珊瑚",
  "block.minecraft.dead_horn_coral": "枯角珊瑚",
  "block.minecraft.dead_tube_coral": "枯管珊瑚",
  "block.minecraft.tube_coral_fan": "扇狀管珊瑚",
  "block.minecraft.brain_coral_fan": "扇狀腦珊瑚",
  "block.minecraft.bubble_coral_fan": "扇狀泡珊瑚",
  "block.minecraft.fire_coral_fan": "扇狀火珊瑚",
  "block.minecraft.horn_coral_fan": "扇狀角珊瑚",
  "block.minecraft.dead_tube_coral_fan": "枯扇狀管珊瑚",
  "block.minecraft.dead_brain_coral_fan": "枯扇狀腦珊瑚",
  "block.minecraft.dead_bubble_coral_fan": "枯扇狀泡珊瑚",
  "block.minecraft.dead_fire_coral_fan": "枯扇狀火珊瑚",
  "block.minecraft.dead_horn_coral_fan": "枯扇狀角珊瑚",
  "block.minecraft.blue_ice": "藍冰",
  "block.minecraft.conduit": "湧靈核",
  "block.minecraft.polished_granite_stairs": "鎣花崗階",
  "block.minecraft.smooth_red_sandstone_stairs": "潤紅砂階",
  "block.minecraft.mossy_stone_brick_stairs": "苔磚階",
  "block.minecraft.polished_diorite_stairs": "鎣閃綠階",
  "block.minecraft.mossy_cobblestone_stairs": "苔䃮階",
  "block.minecraft.end_stone_brick_stairs": "終界巖磚階",
  "block.minecraft.stone_stairs": "巖階",
  "block.minecraft.smooth_sandstone_stairs": "潤砂階",
  "block.minecraft.smooth_quartz_stairs": "潤石英階",
  "block.minecraft.granite_stairs": "花崗階",
  "block.minecraft.andesite_stairs": "鈉滑階",
  "block.minecraft.red_nether_brick_stairs": "焱界紅磚階",
  "block.minecraft.polished_andesite_stairs": "鎣鈉滑階",
  "block.minecraft.diorite_stairs": "閃綠階",
  "block.minecraft.polished_granite_slab": "鎣花崗版",
  "block.minecraft.smooth_red_sandstone_slab": "潤紅砂版",
  "block.minecraft.mossy_stone_brick_slab": "苔磚版",
  "block.minecraft.polished_diorite_slab": "鎣閃綠版",
  "block.minecraft.mossy_cobblestone_slab": "苔䃮版",
  "block.minecraft.end_stone_brick_slab": "終界巖磚版",
  "block.minecraft.smooth_sandstone_slab": "潤砂版",
  "block.minecraft.smooth_quartz_slab": "潤石英版",
  "block.minecraft.granite_slab": "花崗巖版",
  "block.minecraft.andesite_slab": "鈉滑版",
  "block.minecraft.red_nether_brick_slab": "焱界紅磚版",
  "block.minecraft.polished_andesite_slab": "鎣鈉滑版",
  "block.minecraft.diorite_slab": "閃綠版",
  "block.minecraft.scaffolding": "棧架",
  "block.minecraft.iron_door": "鐵門",
  "block.minecraft.oak_door": "柞門",
  "block.minecraft.spruce_door": "樅門",
  "block.minecraft.birch_door": "樺門",
  "block.minecraft.jungle_door": "叢莽門",
  "block.minecraft.acacia_door": "㭜門",
  "block.minecraft.dark_oak_door": "黯柞門",
  "block.minecraft.crimson_door": "緋蕈木門",
  "block.minecraft.warped_door": "譎蕈木門",
  "block.minecraft.repeater": "續赭儀",
  "block.minecraft.comparator": "較赭儀",
  "block.minecraft.structure_block": "結構塊",
  "block.minecraft.jigsaw": "榫卯之塊",
  "item.minecraft.turtle_helmet": "龜殼□□於首：□+2 甲胄",
  "item.minecraft.scute": "鱗",
  "item.minecraft.iron_shovel": "鐵鍁□□於慣用手中：□+3.5 擊力□-3 擊速",
  "item.minecraft.iron_pickaxe": "鐵鎬□□於慣用手中：□+3 擊力□-2.8 擊速",
  "item.minecraft.iron_axe": "鐵斧□□於慣用手中：□+8 擊力□-3.1 擊速",
  "item.minecraft.flint_and_steel": "燧鐮",
  "item.minecraft.apple": "林檎",
  "item.minecraft.bow": "弓",
  "item.minecraft.arrow": "矢",
  "item.minecraft.coal": "石炭",
  "item.minecraft.charcoal": "木炭",
  "item.minecraft.diamond": "金剛石",
  "item.minecraft.iron_ingot": "鐵錠",
  "item.minecraft.gold_ingot": "金錠",
  "item.minecraft.netherite_ingot": "玄鈺錠",
  "item.minecraft.netherite_scrap": "玄鈺殘片",
  "item.minecraft.iron_sword": "鐵劍□□於慣用手中：□+5 擊力□-2.4 擊速",
  "item.minecraft.wooden_sword": "木劍□□於慣用手中：□+3 擊力□-2.4 擊速",
  "item.minecraft.wooden_shovel": "木鍁□□於慣用手中：□+1.5 擊力□-3 擊速",
  "item.minecraft.wooden_pickaxe": "木鎬□□於慣用手中：□+1 擊力□-2.8 擊速",
  "item.minecraft.wooden_axe": "木斧□□於慣用手中：□+6 擊力□-3.2 擊速",
  "item.minecraft.stone_sword": "石劍□□於慣用手中：□+4 擊力□-2.4 擊速",
  "item.minecraft.stone_shovel": "石鍁□□於慣用手中：□+2.5 擊力□-3 擊速",
  "item.minecraft.stone_pickaxe": "石鎬□□於慣用手中：□+2 擊力□-2.8 擊速",
  "item.minecraft.stone_axe": "石斧□□於慣用手中：□+8 擊力□-3.2 擊速",
  "item.minecraft.diamond_sword": "金剛劍□□於慣用手中：□+6 擊力□-2.4 擊速",
  "item.minecraft.diamond_shovel": "金剛鍁□□於慣用手中：□+4.5 擊力□-3 擊速",
  "item.minecraft.diamond_pickaxe": "金剛鎬□□於慣用手中：□+4 擊力□-2.8 擊速",
  "item.minecraft.diamond_axe": "金剛斧□□於慣用手中：□+8 擊力□-3 擊速",
  "item.minecraft.stick": "棍",
  "item.minecraft.bowl": "碗",
  "item.minecraft.mushroom_stew": "蕈羹",
  "item.minecraft.golden_sword": "金劍□□於慣用手中：□+3 擊力□-2.4 擊速",
  "item.minecraft.golden_shovel": "金鍁□□於慣用手中：□+1.5 擊力□-3 擊速",
  "item.minecraft.golden_pickaxe": "金鎬□□於慣用手中：□+1 擊力□-2.8 擊速",
  "item.minecraft.golden_axe": "金斧□□於慣用手中：□+6 擊力□-3 擊速",
  "item.minecraft.netherite_sword": "玄鈺劍□□於慣用手中：□+7 擊力□-2.4 擊速",
  "item.minecraft.netherite_shovel": "玄鈺鍁□□於慣用手中：□+5.5 擊力□-3 擊速",
  "item.minecraft.netherite_pickaxe": "玄鈺鎬□□於慣用手中：□+5 擊力□-2.8 擊速",
  "item.minecraft.netherite_axe": "玄鈺斧□□於慣用手中：□+9 擊力□-3 擊速",
  "item.minecraft.string": "線",
  "item.minecraft.feather": "羽",
  "item.minecraft.gunpowder": "火藥",
  "item.minecraft.wooden_hoe": "木鋤□□於慣用手中：□-3 擊速",
  "item.minecraft.stone_hoe": "石鋤□□於慣用手中：□-2 擊速",
  "item.minecraft.iron_hoe": "鐵鋤□□於慣用手中：□-1 擊速",
  "item.minecraft.diamond_hoe": "金剛鋤□□於慣用手中：",
  "item.minecraft.golden_hoe": "金鋤□□於慣用手中：□-3 擊速",
  "item.minecraft.netherite_hoe": "玄鈺鋤□□於慣用手中：",
  "item.minecraft.wheat_seeds": "麥種",
  "item.minecraft.wheat": "麥",
  "item.minecraft.bread": "麵包",
  "item.minecraft.leather_helmet": "革帽□□於首：□+1 甲胄",
  "item.minecraft.leather_chestplate": "革衣□□於身：□+3 甲胄",
  "item.minecraft.leather_leggings": "革褲□□於腿：□+2 甲胄",
  "item.minecraft.leather_boots": "革靴□□於足：□+1 甲胄",
  "item.minecraft.chainmail_helmet": "環鎖胄□□於首：□+2 甲胄",
  "item.minecraft.chainmail_chestplate": "環鎖鎧□□於身：□+5 甲胄",
  "item.minecraft.chainmail_leggings": "環鎖護腿□□於腿：□+4 甲胄",
  "item.minecraft.chainmail_boots": "環鎖靴□□於足：□+1 甲胄",
  "item.minecraft.iron_helmet": "鐵胄□□於首：□+2 甲胄",
  "item.minecraft.iron_chestplate": "鐵鎧□□於身：□+6 甲胄",
  "item.minecraft.iron_leggings": "鐵護腿□□於腿：□+5 甲胄",
  "item.minecraft.iron_boots": "鐵靴□□於足：□+2 甲胄",
  "item.minecraft.diamond_helmet": "金剛胄□□於首：□+3 甲胄□+2 甲胄之韌",
  "item.minecraft.diamond_chestplate": "金剛鎧□□於身：□+8 甲胄□+2 甲胄之韌",
  "item.minecraft.diamond_leggings": "金剛護腿□□於腿：□+6 甲胄□+2 甲胄之韌",
  "item.minecraft.diamond_boots": "金剛靴□□於足：□+3 甲胄□+2 甲胄之韌",
  "item.minecraft.golden_helmet": "金胄□□於首：□+2 甲胄",
  "item.minecraft.golden_chestplate": "金鎧□□於身：□+5 甲胄",
  "item.minecraft.golden_leggings": "金護腿□□於腿：□+3 甲胄",
  "item.minecraft.golden_boots": "金靴□□於足：□+1 甲胄",
  "item.minecraft.netherite_helmet": "玄鈺胄□□於首：□+3 甲胄□+3 甲胄之韌□+1 禦力",
  "item.minecraft.netherite_chestplate": "玄鈺鎧□□於身：□+8 甲胄□+3 甲胄之韌□+1 禦力",
  "item.minecraft.netherite_leggings": "玄鈺護腿□□於腿：□+6 甲胄□+3 甲胄之韌□+1 禦力",
  "item.minecraft.netherite_boots": "玄鈺靴□□於足：□+3 甲胄□+3 甲胄之韌□+1 禦力",
  "item.minecraft.flint": "燧石",
  "item.minecraft.porkchop": "生豕肉",
  "item.minecraft.cooked_porkchop": "豕炙",
  "item.minecraft.painting": "畫",
  "item.minecraft.golden_apple": "金林檎",
  "item.minecraft.enchanted_golden_apple": "淬靈金林檎",
  "block.minecraft.oak_sign": "柞牌",
  "block.minecraft.spruce_sign": "樅牌",
  "block.minecraft.birch_sign": "樺牌",
  "block.minecraft.jungle_sign": "叢莽牌",
  "block.minecraft.acacia_sign": "㭜牌",
  "block.minecraft.dark_oak_sign": "黯柞牌",
  "block.minecraft.crimson_sign": "緋蕈木牌",
  "block.minecraft.warped_sign": "譎蕈木牌",
  "item.minecraft.bucket": "桶",
  "item.minecraft.water_bucket": "水桶",
  "item.minecraft.lava_bucket": "熔巖桶",
  "item.minecraft.minecart": "礦車",
  "item.minecraft.saddle": "鞍韉",
  "item.minecraft.redstone": "紅石末",
  "item.minecraft.snowball": "雪團",
  "item.minecraft.oak_boat": "柞舟",
  "item.minecraft.leather": "革",
  "item.minecraft.milk_bucket": "乳桶",
  "item.minecraft.pufferfish_bucket": "鯸桶",
  "item.minecraft.salmon_bucket": "鮭桶",
  "item.minecraft.cod_bucket": "鱈桶",
  "item.minecraft.tropical_fish_bucket": "賞魚桶",
  "item.minecraft.brick": "磚",
  "item.minecraft.clay_ball": "埴團",
  "block.minecraft.dried_kelp_block": "海帶乾塊",
  "item.minecraft.paper": "紙",
  "item.minecraft.book": "書",
  "item.minecraft.slime_ball": "黏膠團",
  "item.minecraft.chest_minecart": "箱礦車",
  "item.minecraft.furnace_minecart": "爐礦車",
  "item.minecraft.egg": "雞卵",
  "item.minecraft.compass": "司南",
  "item.minecraft.fishing_rod": "漁竿",
  "item.minecraft.clock": "時鐘",
  "item.minecraft.glowstone_dust": "硄砂",
  "item.minecraft.cod": "生鱈",
  "item.minecraft.salmon": "生鮭",
  "item.minecraft.tropical_fish": "賞魚",
  "item.minecraft.pufferfish": "鯸",
  "item.minecraft.cooked_cod": "鱈炙",
  "item.minecraft.cooked_salmon": "鮭炙",
  "item.minecraft.ink_sac": "墨",
  "item.minecraft.red_dye": "紅染",
  "item.minecraft.green_dye": "綠染",
  "item.minecraft.cocoa_beans": "可可豆",
  "item.minecraft.lapis_lazuli": "群青",
  "item.minecraft.purple_dye": "紫染",
  "item.minecraft.cyan_dye": "黛染",
  "item.minecraft.light_gray_dye": "蒼染",
  "item.minecraft.gray_dye": "灰染",
  "item.minecraft.pink_dye": "粉染",
  "item.minecraft.lime_dye": "翠染",
  "item.minecraft.yellow_dye": "黃染",
  "item.minecraft.light_blue_dye": "縹染",
  "item.minecraft.magenta_dye": "赬染",
  "item.minecraft.orange_dye": "橙染",
  "item.minecraft.bone_meal": "骨塵",
  "item.minecraft.blue_dye": "靛染",
  "item.minecraft.brown_dye": "褐染",
  "item.minecraft.black_dye": "黑染",
  "item.minecraft.white_dye": "白染",
  "item.minecraft.bone": "骨",
  "item.minecraft.sugar": "糖",
  "block.minecraft.cake": "洋糕",
  "block.minecraft.white_bed": "白床",
  "block.minecraft.orange_bed": "橙床",
  "block.minecraft.magenta_bed": "赬床",
  "block.minecraft.light_blue_bed": "縹床",
  "block.minecraft.yellow_bed": "黃床",
  "block.minecraft.lime_bed": "翠床",
  "block.minecraft.pink_bed": "粉床",
  "block.minecraft.gray_bed": "灰床",
  "block.minecraft.light_gray_bed": "蒼床",
  "block.minecraft.cyan_bed": "黛床",
  "block.minecraft.purple_bed": "紫床",
  "block.minecraft.blue_bed": "靛床",
  "block.minecraft.brown_bed": "褐床",
  "block.minecraft.green_bed": "綠床",
  "block.minecraft.red_bed": "紅床",
  "block.minecraft.black_bed": "黑床",
  "item.minecraft.cookie": "餅",
  "item.minecraft.filled_map": "輿圖□#0",
  "item.minecraft.shears": "鉸",
  "item.minecraft.melon_slice": "寒瓜片",
  "item.minecraft.dried_kelp": "乾海帶",
  "item.minecraft.pumpkin_seeds": "南瓜種",
  "item.minecraft.melon_seeds": "寒瓜種",
  "item.minecraft.beef": "生牛肉",
  "item.minecraft.cooked_beef": "牛炙",
  "item.minecraft.chicken": "生雞肉",
  "item.minecraft.cooked_chicken": "鷄炙",
  "item.minecraft.rotten_flesh": "胔",
  "item.minecraft.ender_pearl": "終眇玥",
  "item.minecraft.blaze_rod": "炎靈桿",
  "item.minecraft.ghast_tear": "惡靈淚",
  "item.minecraft.gold_nugget": "金粒",
  "item.minecraft.nether_wart": "焱界疣",
  "item.minecraft.potion": "空劑□無",
  "item.minecraft.glass_bottle": "玻璃瓶",
  "item.minecraft.spider_eye": "蛛目",
  "item.minecraft.fermented_spider_eye": "酵化蛛目",
  "item.minecraft.blaze_powder": "炎靈粉",
  "item.minecraft.magma_cream": "火漿膏",
  "block.minecraft.brewing_stand": "煉藥台",
  "block.minecraft.cauldron": "釜",
  "item.minecraft.ender_eye": "終眇眼",
  "item.minecraft.glistering_melon_slice": "爍寒瓜片",
  "item.minecraft.bat_spawn_egg": "孳蟙䘃之卵",
  "item.minecraft.bee_spawn_egg": "孳蜂之卵",
  "item.minecraft.blaze_spawn_egg": "孳炎靈之卵",
  "item.minecraft.cat_spawn_egg": "孳貓之卵",
  "item.minecraft.cave_spider_spawn_egg": "孳穴蛛之卵",
  "item.minecraft.chicken_spawn_egg": "孳雞之卵",
  "item.minecraft.cod_spawn_egg": "孳鱈之卵",
  "item.minecraft.cow_spawn_egg": "孳牛之卵",
  "item.minecraft.creeper_spawn_egg": "孳伏臨之卵",
  "item.minecraft.dolphin_spawn_egg": "孳海豚之卵",
  "item.minecraft.donkey_spawn_egg": "孳驢之卵",
  "item.minecraft.drowned_spawn_egg": "孳溺屍之卵",
  "item.minecraft.elder_guardian_spawn_egg": "孳古海衛之卵",
  "item.minecraft.enderman_spawn_egg": "孳終眇使之卵",
  "item.minecraft.endermite_spawn_egg": "孳終眇蟎之卵",
  "item.minecraft.evoker_spawn_egg": "孳御魔使之卵",
  "item.minecraft.fox_spawn_egg": "孳狐之卵",
  "item.minecraft.ghast_spawn_egg": "孳惡靈之卵",
  "item.minecraft.guardian_spawn_egg": "孳海衛之卵",
  "item.minecraft.hoglin_spawn_egg": "孳獷豕之卵",
  "item.minecraft.horse_spawn_egg": "孳馬之卵",
  "item.minecraft.husk_spawn_egg": "孳枯屍之卵",
  "item.minecraft.llama_spawn_egg": "孳美洲駝之卵",
  "item.minecraft.magma_cube_spawn_egg": "孳火漿魔之卵",
  "item.minecraft.mooshroom_spawn_egg": "孳哞蕈之卵",
  "item.minecraft.mule_spawn_egg": "孳騾之卵",
  "item.minecraft.ocelot_spawn_egg": "孳虎貓之卵",
  "item.minecraft.panda_spawn_egg": "孳貓熊之卵",
  "item.minecraft.parrot_spawn_egg": "孳鸚鵡之卵",
  "item.minecraft.phantom_spawn_egg": "孳魘靈之卵",
  "item.minecraft.pig_spawn_egg": "孳豕之卵",
  "item.minecraft.piglin_spawn_egg": "孳豕靈之卵",
  "item.minecraft.pillager_spawn_egg": "孳劫寇之卵",
  "item.minecraft.polar_bear_spawn_egg": "孳雪熊之卵",
  "item.minecraft.pufferfish_spawn_egg": "孳鯸之卵",
  "item.minecraft.rabbit_spawn_egg": "孳兔之卵",
  "item.minecraft.ravager_spawn_egg": "孳劫獸之卵",
  "item.minecraft.salmon_spawn_egg": "孳鮭之卵",
  "item.minecraft.sheep_spawn_egg": "孳綿羊之卵",
  "item.minecraft.shulker_spawn_egg": "孳匿贆之卵",
  "item.minecraft.silverfish_spawn_egg": "孳蠧之卵",
  "item.minecraft.skeleton_spawn_egg": "孳髑之卵",
  "item.minecraft.skeleton_horse_spawn_egg": "孳髑馬之卵",
  "item.minecraft.slime_spawn_egg": "孳黏膠魔之卵",
  "item.minecraft.spider_spawn_egg": "孳蛛之卵",
  "item.minecraft.squid_spawn_egg": "孳鰂之卵",
  "item.minecraft.stray_spawn_egg": "孳流髑之卵",
  "item.minecraft.strider_spawn_egg": "孳熾足獸之卵",
  "item.minecraft.trader_llama_spawn_egg": "孳商駝之卵",
  "item.minecraft.tropical_fish_spawn_egg": "孳熱帶魚之卵",
  "item.minecraft.turtle_spawn_egg": "孳海龜之卵",
  "item.minecraft.vex_spawn_egg": "孳惱鬼之卵",
  "item.minecraft.villager_spawn_egg": "孳鄉民之卵",
  "item.minecraft.vindicator_spawn_egg": "孳斫仇者之卵",
  "item.minecraft.wandering_trader_spawn_egg": "孳行商之卵",
  "item.minecraft.witch_spawn_egg": "孳巫之卵",
  "item.minecraft.wither_skeleton_spawn_egg": "孳凋靈髑之卵",
  "item.minecraft.wolf_spawn_egg": "孳狼之卵",
  "item.minecraft.zoglin_spawn_egg": "孳屍化獷豕之卵",
  "item.minecraft.zombie_spawn_egg": "孳殭屍之卵",
  "item.minecraft.zombie_horse_spawn_egg": "孳屍馬之卵",
  "item.minecraft.zombie_villager_spawn_egg": "孳屍化鄉民之卵",
  "item.minecraft.zombified_piglin_spawn_egg": "孳屍化豕靈之卵",
  "item.minecraft.experience_bottle": "淬靈瓶",
  "item.minecraft.fire_charge": "焰彈",
  "item.minecraft.writable_book": "書與筆",
  "item.minecraft.written_book": "成書",
  "item.minecraft.emerald": "祖母綠",
  "item.minecraft.item_frame": "置具框",
  "block.minecraft.flower_pot": "盆",
  "item.minecraft.carrot": "胡蘿蔔",
  "item.minecraft.potato": "洋芋",
  "item.minecraft.baked_potato": "烤洋芋",
  "item.minecraft.poisonous_potato": "毒洋芋",
  "item.minecraft.map": "空圖",
  "item.minecraft.golden_carrot": "金胡蘿蔔",
  "block.minecraft.skeleton_skull": "髑首",
  "block.minecraft.wither_skeleton_skull": "凋靈髑首",
  "block.minecraft.player_head": "戲者之首",
  "block.minecraft.zombie_head": "屍首",
  "block.minecraft.creeper_head": "伏臨首",
  "block.minecraft.dragon_head": "龍首",
  "item.minecraft.carrot_on_a_stick": "胡蘿蔔釣竿",
  "item.minecraft.warped_fungus_on_a_stick": "譎蕈釣竿",
  "item.minecraft.nether_star": "焱界之星",
  "item.minecraft.pumpkin_pie": "南瓜餅",
  "item.minecraft.firework_rocket": "焰火",
  "item.minecraft.firework_star": "焰火之星",
  "item.minecraft.enchanted_book": "淬靈書",
  "item.minecraft.nether_brick": "焱界磚",
  "item.minecraft.quartz": "石英",
  "item.minecraft.tnt_minecart": "炸藥礦車",
  "item.minecraft.hopper_minecart": "漏斗礦車",
  "item.minecraft.prismarine_shard": "海磷",
  "item.minecraft.prismarine_crystals": "海磷晶",
  "item.minecraft.rabbit": "生兔肉",
  "item.minecraft.cooked_rabbit": "兔炙",
  "item.minecraft.rabbit_stew": "兔肉羹",
  "item.minecraft.rabbit_foot": "兔足",
  "item.minecraft.rabbit_hide": "兔皮",
  "item.minecraft.armor_stand": "甲桁",
  "item.minecraft.iron_horse_armor": "鐵馬甲",
  "item.minecraft.golden_horse_armor": "金馬甲",
  "item.minecraft.diamond_horse_armor": "金剛馬甲",
  "item.minecraft.leather_horse_armor": "皮馬甲",
  "item.minecraft.lead": "韁",
  "item.minecraft.name_tag": "名刺",
  "item.minecraft.command_block_minecart": "命令塊礦車",
  "item.minecraft.mutton": "生羊肉",
  "item.minecraft.cooked_mutton": "羊炙",
  "block.minecraft.white_banner": "白旗",
  "block.minecraft.orange_banner": "橙旗",
  "block.minecraft.magenta_banner": "赬旗",
  "block.minecraft.light_blue_banner": "縹旗",
  "block.minecraft.yellow_banner": "黃旗",
  "block.minecraft.lime_banner": "翠旗",
  "block.minecraft.pink_banner": "粉旗",
  "block.minecraft.gray_banner": "灰旗",
  "block.minecraft.light_gray_banner": "蒼旗",
  "block.minecraft.cyan_banner": "黛旗",
  "block.minecraft.purple_banner": "紫旗",
  "block.minecraft.blue_banner": "靛旗",
  "block.minecraft.brown_banner": "褐旗",
  "block.minecraft.green_banner": "綠旗",
  "block.minecraft.red_banner": "紅旗",
  "block.minecraft.black_banner": "玄旗",
  "item.minecraft.end_crystal": "終界水玉",
  "item.minecraft.chorus_fruit": "頌緲果",
  "item.minecraft.popped_chorus_fruit": "裂頌緲果",
  "item.minecraft.beetroot": "甜菜根",
  "item.minecraft.beetroot_seeds": "甜菜種",
  "item.minecraft.beetroot_soup": "甜菜羹",
  "item.minecraft.dragon_breath": "龍涎",
  "item.minecraft.splash_potion": "空噴劑□無",
  "item.minecraft.spectral_arrow": "爍靈矢",
  "item.minecraft.tipped_arrow": "不可製之藥矢□無",
  "item.minecraft.lingering_potion": "空滯劑□無",
  "item.minecraft.shield": "盾",
  "item.minecraft.elytra": "翼",
  "item.minecraft.spruce_boat": "樅舟",
  "item.minecraft.birch_boat": "樺舟",
  "item.minecraft.jungle_boat": "叢莽舟",
  "item.minecraft.acacia_boat": "㭜舟",
  "item.minecraft.dark_oak_boat": "黯柞舟",
  "item.minecraft.totem_of_undying": "保命符",
  "item.minecraft.shulker_shell": "匿贆殼",
  "item.minecraft.iron_nugget": "鐵粒",
  "item.minecraft.knowledge_book": "天工開物",
  "item.minecraft.debug_stick": "勘誤棍",
  "item.minecraft.music_disc_13": "留聲盤□c418 - 13",
  "item.minecraft.music_disc_cat": "留聲盤□c418 - cat",
  "item.minecraft.music_disc_blocks": "留聲盤□c418 - blocks",
  "item.minecraft.music_disc_chirp": "留聲盤□c418 - chirp",
  "item.minecraft.music_disc_far": "留聲盤□c418 - far",
  "item.minecraft.music_disc_mall": "留聲盤□c418 - mall",
  "item.minecraft.music_disc_mellohi": "留聲盤□c418 - mellohi",
  "item.minecraft.music_disc_stal": "留聲盤□c418 - stal",
  "item.minecraft.music_disc_strad": "留聲盤□c418 - strad",
  "item.minecraft.music_disc_ward": "留聲盤□c418 - ward",
  "item.minecraft.music_disc_11": "留聲盤□c418 - 11",
  "item.minecraft.music_disc_wait": "留聲盤□c418 - wait",
  "item.minecraft.music_disc_pigstep": "留聲盤□lena raine - pigstep",
  "item.minecraft.trident": "三叉戟□□於慣用手中：□+8 擊力□-2.9 擊速",
  "item.minecraft.phantom_membrane": "魘靈膜",
  "item.minecraft.nautilus_shell": "鸚鵡螺殼",
  "item.minecraft.heart_of_the_sea": "海之心",
  "item.minecraft.crossbow": "弩",
  "item.minecraft.suspicious_stew": "迷羹",
  "block.minecraft.loom": "機杼",
  "item.minecraft.flower_banner_pattern": "旗楷□菊紋",
  "item.minecraft.creeper_banner_pattern": "旗楷□伏臨紋",
  "item.minecraft.skull_banner_pattern": "旗楷□髑顱紋",
  "item.minecraft.mojang_banner_pattern": "旗楷□魔讚",
  "item.minecraft.globe_banner_pattern": "旗楷□星球紋",
  "item.minecraft.piglin_banner_pattern": "旗楷□豕鼻",
  "block.minecraft.composter": "肥箱",
  "block.minecraft.barrel": "桶",
  "block.minecraft.smoker": "燻爐",
  "block.minecraft.blast_furnace": "冶爐",
  "block.minecraft.cartography_table": "輿圖案",
  "block.minecraft.fletching_table": "製箭案",
  "block.minecraft.grindstone": "礪",
  "block.minecraft.lectern": "書檯",
  "block.minecraft.smithing_table": "鍛案",
  "block.minecraft.stonecutter": "鑿石器",
  "block.minecraft.bell": "鐘",
  "block.minecraft.lantern": "燈籠",
  "block.minecraft.soul_lantern": "靈燈",
  "item.minecraft.sweet_berries": "甜莓",
  "block.minecraft.campfire": "營火",
  "block.minecraft.soul_campfire": "靈篝火",
  "block.minecraft.shroomlight": "螢蕈體",
  "item.minecraft.honeycomb": "蜜脾",
  "block.minecraft.bee_nest": "蜂巢",
  "block.minecraft.beehive": "蜂箱",
  "item.minecraft.honey_bottle": "蜜瓶",
  "block.minecraft.honey_block": "蜜塊",
  "block.minecraft.honeycomb_block": "蜜脾塊",
  "block.minecraft.lodestone": "磁石",
  "block.minecraft.netherite_block": "玄鈺塊",
  "block.minecraft.ancient_debris": "上古之骸",
  "block.minecraft.target": "靶",
  "block.minecraft.crying_obsidian": "泣黑曜石",
  "block.minecraft.blackstone": "墨石",
  "block.minecraft.blackstone_slab": "墨石版",
  "block.minecraft.blackstone_stairs": "墨石階",
  "block.minecraft.gilded_blackstone": "嵌金之墨石",
  "block.minecraft.polished_blackstone": "鎣黑巖",
  "block.minecraft.polished_blackstone_slab": "鎣黑巖版",
  "block.minecraft.polished_blackstone_stairs": "鎣黑巖階",
  "block.minecraft.chiseled_polished_blackstone": "鏨鎣墨石",
  "block.minecraft.polished_blackstone_bricks": "鎣墨石磚",
  "block.minecraft.polished_blackstone_brick_slab": "鎣墨石磚版",
  "block.minecraft.polished_blackstone_brick_stairs": "鎣墨石磚階",
  "block.minecraft.cracked_polished_blackstone_bricks": "裂鎣墨石磚",
  "block.minecraft.respawn_anchor": "復生錨",
}
export const lzh = items; 
